import{useEffect as Mt,useRef as Lt}from"react";import*as Ve from"react-dom";import{Fragment as Nt,useEffect as xe,useMemo as Et,useRef as ze,useState as Pe}from"react";import Oe from"classnames";import{jsx as $e}from"react/jsx-runtime";var Ge={baseline:"vuiFlexContainer--alignItemsBaseline",center:"vuiFlexContainer--alignItemsCenter",end:"vuiFlexContainer--alignItemsEnd",start:"vuiFlexContainer--alignItemsStart",stretch:"vuiFlexContainer--alignItemsStretch"},qe={column:"vuiFlexContainer--directionColumn",columnReverse:"vuiFlexContainer--directionColumnReverse",row:"vuiFlexContainer--directionRow",rowReverse:"vuiFlexContainer--directionRowReverse"},We={center:"vuiFlexContainer--justifyContentCenter",end:"vuiFlexContainer--justifyContentEnd",start:"vuiFlexContainer--justifyContentStart",spaceAround:"vuiFlexContainer--justifyContentSpaceAround",spaceBetween:"vuiFlexContainer--justifyContentSpaceBetween",spaceEvenly:"vuiFlexContainer--justifyContentSpaceEvenly"},je={none:"vuiFlexContainer--spacingNone",xxs:"vuiFlexContainer--spacingXxs",xs:"vuiFlexContainer--spacingXs",s:"vuiFlexContainer--spacingS",m:"vuiFlexContainer--spacingM",l:"vuiFlexContainer--spacingL",xl:"vuiFlexContainer--spacingXl",xxl:"vuiFlexContainer--spacingXxl"},B=({children:e,alignItems:t="stretch",direction:r="row",justifyContent:n="start",spacing:i="m",wrap:o,className:a,fullWidth:s,...l})=>{let c=Oe(a,"vuiFlexContainer",Ge[t],qe[r],We[n],je[i],{"vuiFlexContainer--wrap":o,"vuiFlexContainer--fullWidth":s});return $e("div",{className:c,...l,children:e})};import Xe from"classnames";import{jsx as Ze}from"react/jsx-runtime";var Ue={baseline:"vuiFlexItem--alignItemsBaseline",center:"vuiFlexItem--alignItemsCenter",end:"vuiFlexItem--alignItemsEnd",start:"vuiFlexItem--alignItemsStart",stretch:"vuiFlexItem--alignItemsStretch"},v=({children:e,grow:t,shrink:r,basis:n="auto",alignItems:i="stretch",className:o,truncate:a,...s})=>{let l=t===!1,c=r===!1,p=Xe("vuiFlexItem",`vuiFlexItem--${n}`,Ue[i],{[`vuiFlexItem--flexGrow${t}`]:typeof t=="number","vuiFlexItem--flexGrowNone":l,[`vuiFlexItem--flexShrink${r}`]:typeof r=="number","vuiFlexItem--flexShrinkNone":c,"vuiFlexItem--truncate":a},o);return Ze("div",{className:p,...s,children:e})};var $=0,te=()=>($===Number.MAX_SAFE_INTEGER?$=0:$++,$.toString());import{jsx as u,jsxs as N}from"react/jsx-runtime";var he=({size:e,color:t})=>u("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.26933 329",width:e,height:e,fill:t,children:u("path",{d:"m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"})}),ve=({size:e="16px",color:t="#ffffff"})=>N("svg",{fill:t,version:"1.1",id:"Capa_1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",width:e,height:e,viewBox:"0 0 29.75 29.75",xmlSpace:"preserve",children:[u("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),u("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),N("g",{id:"SVGRepo_iconCarrier",children:[" ",N("g",{children:[" ",N("g",{children:[" ",u("path",{d:"M26.573,4.026H5.163c-1.884,0-3.413,1.707-3.413,3.321v12.976c0,0.001,0,0.002,0,0.003l-0.004-0.003L0,25.724l4.913-2.717 c0.084,0.004,0.164,0.02,0.25,0.02h21.41c1.884,0,3.177-1.09,3.177-2.703V7.347C29.75,5.733,28.457,4.026,26.573,4.026z M27.75,20.323c0,0.538-0.548,0.703-1.177,0.703H5.163c-0.629,0-1.413-0.165-1.413-0.703V7.347c0-0.539,0.784-1.321,1.413-1.321 h21.41c0.629,0,1.177,0.782,1.177,1.321V20.323z"})," ",N("g",{children:[" ",u("circle",{cx:"9.274",cy:"13.526",r:"1.874"})," ",u("circle",{cx:"15.657",cy:"13.526",r:"1.874"})," ",u("circle",{cx:"22.04",cy:"13.526",r:"1.874"})," "]})," "]})," "]})," "]})]}),be=()=>N("svg",{fill:"#c41535",width:"16px",height:"16px",viewBox:"0 0 1024 1024",xmlns:"http://www.w3.org/2000/svg",stroke:"#c41535",strokeWidth:"20",children:[u("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),u("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),u("g",{id:"SVGRepo_iconCarrier",children:u("path",{d:"M520.741 163.801a10.234 10.234 0 00-3.406-3.406c-4.827-2.946-11.129-1.421-14.075 3.406L80.258 856.874a10.236 10.236 0 00-1.499 5.335c0 5.655 4.585 10.24 10.24 10.24h846.004c1.882 0 3.728-.519 5.335-1.499 4.827-2.946 6.352-9.248 3.406-14.075L520.742 163.802zm43.703-26.674L987.446 830.2c17.678 28.964 8.528 66.774-20.436 84.452a61.445 61.445 0 01-32.008 8.996H88.998c-33.932 0-61.44-27.508-61.44-61.44a61.445 61.445 0 018.996-32.008l423.002-693.073c17.678-28.964 55.488-38.113 84.452-20.436a61.438 61.438 0 0120.436 20.436zM512 778.24c22.622 0 40.96-18.338 40.96-40.96s-18.338-40.96-40.96-40.96-40.96 18.338-40.96 40.96 18.338 40.96 40.96 40.96zm0-440.32c-22.622 0-40.96 18.338-40.96 40.96v225.28c0 22.622 18.338 40.96 40.96 40.96s40.96-18.338 40.96-40.96V378.88c0-22.622-18.338-40.96-40.96-40.96z"})})]}),ye=()=>N("svg",{width:"10px",height:"10px",viewBox:"-5.5 0 26 26",version:"1.1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",fill:"#2c313a",children:[u("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),u("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),N("g",{id:"SVGRepo_iconCarrier",children:[" ",u("title",{children:"chevron-right"})," ",u("desc",{children:"Created with Sketch Beta."})," ",u("defs",{children:" "})," ",N("g",{id:"Page-1",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",children:[" ",N("g",{id:"Icon-Set-Filled",transform:"translate(-474.000000, -1196.000000)",fill:"#2c313a",children:[" ",u("path",{d:"M488.404,1207.36 L477.637,1197.6 C476.806,1196.76 475.459,1196.76 474.629,1197.6 C473.798,1198.43 473.798,1199.77 474.629,1200.6 L483.885,1209 L474.629,1217.4 C473.798,1218.23 473.798,1219.57 474.629,1220.4 C475.459,1221.24 476.806,1221.24 477.637,1220.4 L488.404,1210.64 C488.854,1210.19 489.052,1209.59 489.015,1209 C489.052,1208.41 488.854,1207.81 488.404,1207.36",id:"chevron-right",children:" "})," "]})," "]})," "]})]}),Ce=()=>N("svg",{width:"10px",height:"10px",viewBox:"0 -4.5 24 24",version:"1.1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",fill:"#2c313a",children:[u("g",{id:"SVGRepo_bgCarrier",strokeWidth:"0"}),u("g",{id:"SVGRepo_tracerCarrier",strokeLinecap:"round",strokeLinejoin:"round"}),N("g",{id:"SVGRepo_iconCarrier",children:[" ",u("title",{children:"chevron-down"})," ",u("desc",{children:"Created with Sketch Beta."})," ",u("defs",{children:" "})," ",N("g",{id:"Page-1",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",children:[" ",N("g",{id:"Icon-Set-Filled",transform:"translate(-574.000000, -1201.000000)",fill:"#2c313a",children:[" ",u("path",{d:"M597.405,1201.63 C596.576,1200.8 595.23,1200.8 594.401,1201.63 L586.016,1210.88 L577.63,1201.63 C576.801,1200.8 575.455,1200.8 574.626,1201.63 C573.797,1202.46 573.797,1203.81 574.626,1204.64 L584.381,1215.4 C584.83,1215.85 585.429,1216.05 586.016,1216.01 C586.603,1216.05 587.201,1215.85 587.65,1215.4 L597.405,1204.64 C598.234,1203.81 598.234,1202.46 597.405,1201.63",id:"chevron-down",children:" "})," "]})," "]})," "]})]});import{Fragment as Ke,jsx as H,jsxs as Se}from"react/jsx-runtime";var re=({header:e,children:t,isOpen:r,setIsOpen:n,...i})=>{let o=te(),a=te();return Se(Ke,{children:[H("button",{className:"vuiAccordionHeader",onClick:()=>n(!r),id:o,"aria-controls":a,"aria-expanded":r,...i,children:Se(B,{alignItems:"center",justifyContent:"start",spacing:"xxs",children:[H(v,{grow:!1,shrink:!1,children:r?H(Ce,{}):H(ye,{})}),H(v,{className:"vuiAccordionHeader__title",grow:1,children:e})]})}),r&&H("div",{id:a,"aria-labelledby":o,children:t})]})};import{forwardRef as rt}from"react";import nt from"classnames";import{forwardRef as Qe}from"react";import Ie from"classnames";var we=e=>e?{rel:"noopener",referrerpolicy:"no-referrer-when-downgrade"}:{rel:"noopener"};import{jsx as Be,jsxs as ne}from"react/jsx-runtime";var Je={left:"vuiBaseButton--alignLeft",center:"vuiBaseButton--alignCenter",right:"vuiBaseButton--alignRight"},X=Qe(({children:e,icon:t,iconSide:r="left",align:n="center",className:i,size:o,fullWidth:a,onClick:s,tabIndex:l,isInert:c,isDisabled:p,href:g,target:f,track:S,htmlFor:m,isSubmit:w,...F},y)=>{let b=Ie("vuiBaseButton",i,`vuiBaseButton--${o}`,Je[n],{"vuiBaseButton-isInert":c,"vuiBaseButton-isDisabled":p,"vuiBaseButton--fullWidth":a,[`vuiBaseButton--${r}`]:!!t&&!!e}),E=t?Be("span",{className:"vuiBaseButtonIconContainer",children:t}):null;if(m)return ne("label",{htmlFor:m,className:b,tabIndex:l,...F,children:[E,e]});if(g){let R=Ie("vuiBaseButtonLinkWrapper",{"vuiBaseButtonLinkWrapper--fullWidth":a});return Be("a",{className:R,href:g,onClick:s,target:f,tabIndex:l,...F,...we(S),children:ne("button",{className:b,tabIndex:-1,ref:y,children:[E,e]})})}let k={onClick:s,tabIndex:l,type:w?"submit":"button",...F};return ne("button",{className:b,...k,ref:y,children:[E,e]})});import{cloneElement as Ye}from"react";var et={xs:"xs",s:"xs",m:"s",l:"m"},tt={accent:"accent",primary:"primary",success:"success",danger:"danger",warning:"warning",neutral:"neutral",subdued:"subdued"},U=(e,t,r,n=tt)=>e?Ye(e,{size:t?et[t]:"s",color:e.props.color==="inherit"?n[r]:e.props.color}):null;import{jsx as ot}from"react/jsx-runtime";var it={accent:"empty",primary:"empty",success:"empty",danger:"empty",warning:"empty",neutral:"neutral",subdued:"subdued"},ie=rt(({children:e,icon:t,color:r,size:n="m",className:i,isSelected:o,isDisabled:a,...s},l)=>{let c=nt(i,"vuiButtonPrimary",`vuiButtonPrimary--${r}`,{"vuiButtonPrimary-isSelected":o}),p=U(t,n,r,it);return ot(X,{ref:l,className:c,icon:p,size:n,isDisabled:a,...s,children:e})});import{forwardRef as at}from"react";import st from"classnames";import{jsx as ct}from"react/jsx-runtime";var lt={accent:"accent",primary:"primary",success:"success",danger:"danger",warning:"warning",neutral:"neutral",subdued:"subdued"},oe=at(({children:e,icon:t,color:r,size:n="m",className:i,isSelected:o,isDisabled:a,solid:s,...l},c)=>{let p=st(i,"vuiButtonSecondary",`vuiButtonSecondary--${r}`,{"vuiButtonSecondary-isSelected":o,"vuiButtonSecondary--solid":s}),g=U(t,n,r,lt);return ct(X,{ref:c,className:p,icon:g,size:n,isDisabled:a,...l,children:e})});import ut from"classnames";import{jsx as ae}from"react/jsx-runtime";var se=({className:e,size:t="m",value:r,onChange:n,placeholder:i,autoFocus:o,onSubmit:a,...s})=>{let l=ut("vuiSearchInput",`vuiSearchInput--${t}`,e);return ae("form",{onSubmit:a,children:ae("div",{className:l,children:ae("input",{className:"vuiSearchInput__input",type:"text",autoComplete:"off",autoCapitalize:"off",spellCheck:"false",autoFocus:o,placeholder:i,value:r,onChange:n,...s})})})};import pt from"classnames";import{jsx as dt}from"react/jsx-runtime";var T=({size:e="m"})=>{let t=pt("vuiSpacer",{[`vuiSpacer--${e}`]:e});return dt("div",{className:t})};import mt from"classnames";import{jsx as Z}from"react/jsx-runtime";var xt={xs:"vuiSpinner--xs",s:"vuiSpinner--s",m:"vuiSpinner--m",l:"vuiSpinner--l",xl:"vuiSpinner--xl",xxl:"vuiSpinner--xxl",xxxl:"vuiSpinner--xxxl"},le=({color:e="accent",size:t="m"})=>{let r=mt("vuiSpinner",xt[t],`vuiSpinner--${e}`);return Z("span",{className:r,children:Z("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 50 50",children:Z("path",{fill:"#000",d:"M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z",children:Z("animateTransform",{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 25 25",to:"360 25 25",dur:"0.6s",repeatCount:"indefinite"})})})})};import gt from"classnames";import{jsx as ft}from"react/jsx-runtime";var G=({children:e,className:t,id:r,truncate:n,size:i="s",align:o,...a})=>{let s=gt("vuiText",`vuiText--${i}`,{[`vuiText--${o}`]:o,"vuiText--truncate":n},t);return ft("div",{className:s,id:r,...a,children:e})};import Vr from"classnames";import{jsx as Ar}from"react/jsx-runtime";import Gr from"classnames";import{cloneElement as jr}from"react";import{jsx as K,jsxs as ht}from"react/jsx-runtime";var Te=({query:e,setQuery:t,onSubmit:r,placeholder:n,buttonLabel:i,isButtonDisabled:o,size:a})=>ht(B,{alignItems:"center",spacing:"xs",children:[K(v,{grow:1,children:K(se,{size:a,value:e,onChange:c=>{t(c.target.value)},onSubmit:c=>{c.preventDefault(),r()},placeholder:n,autoFocus:!0,"data-testid":"queryInput"})}),K(v,{children:K(ie,{color:"primary",size:a,onClick:()=>r(),isDisabled:o,children:i})})]});import yt from"markdown-to-jsx";var ce=(e,t)=>{let r=[],n=t.match(/\[\d+\]/g)||[],i=new Set;for(let o=0;o<n.length;o++){let a=n[o],s=Number(a.slice(1,a.length-1))-1;i.has(s)||(r.push(e[s]),i.add(s))}return r};var ue=e=>{let t=/\[(\d+(,*\s*\d*)*)\]/g,r=[],n,i=0;for(;(n=t.exec(e))!==null;){let a=n.index,s=n[1],l=e.slice(i,a).trim();r.push({text:l,references:s.replace(/\s/g,"").split(",")}),i=a+n[0].length}let o=e.slice(i).trim();return o.length>0&&r.push({text:o}),r};var pe=e=>{let t=e.match(/\[\d+\]/g)||[],r=[...new Set(t)],n={};return r.forEach((i,o)=>{n[i]=`[${o+1}]`}),e.replace(/\[\d+\]/g,i=>n[i])};import{Fragment as bt,jsx as V,jsxs as de}from"react/jsx-runtime";var Fe=({searchResults:e,isOpen:t=!1,setIsOpen:r=()=>{}})=>de(re,{header:`Based on ${e.length} ${e.length===1?"fact":"facts"}`,isOpen:t,setIsOpen:r,children:[V(T,{size:"s"}),e.map((n,i)=>de("div",{children:[V(vt,{result:n,position:i}),i<e.length-1&&V(T,{size:"s"})]},i))]}),vt=({result:e,position:t})=>{var i;let r=(i=e==null?void 0:e.snippet)==null?void 0:i.text,n=e==null?void 0:e.url;return V(bt,{children:de(B,{alignItems:"start",spacing:"s",children:[V(v,{grow:!1,shrink:!1,children:V("div",{className:"vrcbChatSearchResultPosition",children:t+1})}),V(v,{grow:1,shrink:1,children:V(G,{size:"s",children:V("p",{children:n?V("a",{href:n,target:"_blank",children:r}):r})})})]})})};import{useState as Ct}from"react";import{Fragment as Q,jsx as C,jsxs as _}from"react/jsx-runtime";var St=e=>ue(e).reduce((r,{text:n,references:i})=>(i?(r.push(n),n&&n[n.length-1]!==" "&&r.push(" "),i.forEach((a,s)=>{s>0&&r.push(" "),r.push(`<SummaryCitation reference={${a}} />`)})):r.push(n),r),[]).join(" "),me=({question:e,answer:t,searchResults:r,onRetry:n,isStreaming:i})=>{let[o,a]=Ct(!1),s;if(n)s=_("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--error",children:[C(T,{size:"m"}),_(B,{alignItems:"center",spacing:"none",children:[_(B,{alignItems:"center",spacing:"xxs",children:[C(v,{grow:!1,shrink:!0,children:C(be,{})}),C(v,{grow:!1,children:"Message not sent."})]}),n&&_(Q,{children:[C(T,{size:"s"}),C(B,{alignItems:"center",spacing:"none",children:C("button",{className:"vrcbRetryButton",onClick:()=>n(),children:"Try again"})})]})]})]});else if(t){let l=(r?ce(r,t):[]).slice(0,7),c=r?pe(t):t,p=St(c);s=C("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--answer",children:_("div",{className:"vrcbChatMessage",children:[_(G,{size:"s",children:[C(yt,{children:p,options:{forceInline:!0,overrides:{SummaryCitation:{component:({reference:f})=>_(Q,{children:[" ",C("button",{onClick:()=>a(!0),children:C("span",{className:"vrcbChatSummaryCitation",children:f})})]})}}}}),i&&_("span",{children:[" ",C(le,{size:"xs"})]})]}),l&&l.length>0&&_(Q,{children:[C(T,{size:"s"}),C(Fe,{searchResults:l,isOpen:o,setIsOpen:a})]})]})})}return _(Q,{children:[C("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--question",children:C("div",{className:"vrcbChatMessage",children:e})}),C(T,{size:"xs"}),s]})};import{useEffect as Tt,useRef as Ft,useState as O}from"react";import{streamQuery as kt}from"@vectara/stream-query-client";var ke=async({filter:e,queryValue:t,language:r,summaryMode:n,rerank:i,rerankNumResults:o,rerankerId:a,rerankDiversityBias:s,hybridNumWords:l,hybridLambdaShort:c,hybridLambdaLong:p,summaryNumResults:g,summaryNumSentences:f,summaryPromptName:S,customerId:m,corpusId:w,endpoint:F,apiKey:y,chat:b})=>{let E=typeof t>"u"||t.trim().split(" ").length>l?p:c,k=w.split(",").map(h=>({customerId:m,corpusId:h,lexicalInterpolationConfig:{lambda:E},metadataFilter:e?`doc.source = '${e}'`:void 0})),R={query:[{query:t,start:0,numResults:i?o:10,corpusKey:k,contextConfig:{sentencesBefore:n?f:2,sentencesAfter:n?f:2,startTag:J,endTag:Y},...n?{summary:[{responseLang:r,maxSummarizedResults:g,summarizerPromptName:S,chat:{store:!0,conversationId:b==null?void 0:b.conversationId}}]}:{},...i?{rerankingConfig:{rerankerId:a,...a===272725718?{mmrConfig:{diversityBias:s}}:{}}}:{}}]},I=`https://${F}/v1/query`,x=await fetch(I,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json","customer-id":m,"x-api-key":y,"grpc-timeout":"60S","x-source":"react-chatbot"},body:JSON.stringify(R)});if(x.status!==200)throw new Error(x.status.toString());let z=await x.json(),L=z.responseSet[0].status;if(L.length>0&&L[0].code==="UNAUTHORIZED"&&console.log("UNAUTHORIZED access; check your API key and customer ID"),n){let h=z.responseSet[0].summary[0].status;if(h.length>0&&h[0].code==="BAD_REQUEST")throw new Error("BAD REQUEST: Too much text for the summarizer to summarize. Please try reducing the number of search results to summarize, or the context of each result by adjusting the 'summary_num_sentences', and 'summary_num_results' parameters respectively.");if(h.length>0&&h[0].code==="NOT_FOUND"&&h[0].statusDetail==="Failed to retrieve summarizer.")throw new Error(`BAD REQUEST: summarizer ${S} is invalid for this account.`)}return z.responseSet[0]},J="%START_SNIPPET%",Y="%END_SNIPPET%";var Re=e=>{if(!e)return;let t=[],{response:r,document:n}=e;return r.forEach(i=>{let{documentIndex:o,text:a}=i,{pre:s,post:l,text:c}=It(a),p=n[Number(o)],{id:g,metadata:f}=p,{source:S,url:m,title:w,metadata:F}=wt(f);t.push({id:g,snippet:{pre:s,text:c,post:l},source:S,url:m,title:w,metadata:F})}),t},wt=e=>{let t=Bt(e);return{source:t.source,url:t.url,title:t.title||"Untitled",metadata:t}},It=e=>{let[t,r]=e.indexOf(J)!==-1?e.split(J):["",e],[n,i]=r.indexOf(Y)!==-1?r.split(Y):[r,""];return{pre:t,post:i,text:n}},Bt=e=>{let t={};return e.forEach(r=>{t[r.name]=r.value}),t};var Ne=(e,t,r,n=!0,i="eng")=>{let[o,a]=O([]),s=Ft(""),[l,c]=O(null),[p,g]=O(!1),[f,S]=O(!1),[m,w]=O(null),[F,y]=O(!1),b=async({query:R,isRetry:I=!1})=>{if(p)return;I&&y(!1),c(null),s.current=R,c({id:"placeholder-message-id",question:R,answer:"",results:[]});let P={filter:"",queryValue:R,rerank:!0,rerankNumResults:7,rerankerId:272725718,rerankDiversityBias:.3,customerId:e,corpusId:t.join(","),endpoint:"api.vectara.io",apiKey:r};if(g(!0),n)try{await kt({...P,corpusIds:t,summaryNumResults:7,summaryNumSentences:3,summaryPromptName:"vectara-summary-ext-v1.2.0",language:i,chat:{store:!0,conversationId:m!=null?m:void 0}},x=>k(x))}catch(x){console.log("Summary error",x),g(!1),y(!0);return}else try{let x=await ke({...P,hybridNumWords:2,hybridLambdaLong:0,hybridLambdaShort:.1,summaryMode:!0,summaryNumResults:7,summaryNumSentences:3,summaryPromptName:"vectara-summary-ext-v1.2.0",language:i,chat:{conversationId:m!=null?m:void 0}});w(x.summary[0].chat.conversationId),a(z=>{var L,h;return[...z,{id:x.summary[0].chat.turnId,question:s.current,answer:(L=x==null?void 0:x.summary[0].text)!=null?L:"",results:(h=Re(x))!=null?h:[]}]}),c(null),g(!1)}catch(x){console.log("Summary error",x),y(!0),g(!1);return}},E=()=>{a([]),w(null)},k=({references:R,details:I,updatedText:P,isDone:x})=>{var L;P&&(S(!0),g(!1));let z=I==null?void 0:I.find(h=>h.type==="chat");z&&w((L=z.data.conversationId)!=null?L:null),x?S(!1):c(h=>{var W;return{id:z?z.data.turnId:"",question:s.current,answer:P!=null?P:"",results:[...(W=h==null?void 0:h.results)!=null?W:[],...R!=null?R:[]]}})};return Tt(()=>{!f&&l&&(a([...o,l]),c(null))},[f]),{sendMessage:b,activeMessage:l,messageHistory:o,isLoading:p,isStreamingResponse:f,startNewConversation:E,hasError:F}};import{Fragment as Rt,jsx as ee}from"react/jsx-runtime";var Ee=()=>ee(Rt,{children:ee("div",{className:"vrcbChatMessageContainer vrcbChatMessageContainer--thinking",children:ee("div",{className:"vrcbChatMessage",children:ee("div",{className:"vrcbLoader"})})})});import{Fragment as Me,jsx as d,jsxs as D}from"react/jsx-runtime";var zt={large:"l",medium:"m"},Pt=()=>D(B,{className:"vrcbEmptyMessages",spacing:"none",alignItems:"center",justifyContent:"center",direction:"column",children:[d(ve,{size:"150px",color:"#000000"}),"Ask anything."]}),Le=({customerId:e,corpusIds:t,apiKey:r,title:n="My Chatbot",placeholder:i="Chat with your AI Assistant",inputSize:o="large",emptyStateDisplay:a=d(Pt,{}),isInitiallyOpen:s,zIndex:l=9999,enableStreaming:c,language:p})=>{let[g,f]=Pe(s!=null?s:!1),[S,m]=Pe(""),{sendMessage:w,startNewConversation:F,messageHistory:y,isLoading:b,hasError:E,activeMessage:k,isStreamingResponse:R}=Ne(e,t,r,c,p),I=ze(null),P=ze(!0),x=()=>{setTimeout(()=>{var M,A;P.current&&((A=I.current)==null||A.scrollTo({left:0,top:(M=I.current)==null?void 0:M.scrollHeight,behavior:"smooth"}))},0)};xe(()=>{s!==void 0&&f(s)},[s]),xe(()=>{let M=I.current,A=()=>{let j=I.current?Math.abs(I.current.scrollHeight-I.current.clientHeight-I.current.scrollTop)<50:!0;P.current=j};return M==null||M.addEventListener("scroll",A),()=>{M==null||M.removeEventListener("scroll",A)}},[]);let z=Et(()=>y.map((M,A)=>{let{question:j,answer:Ae,results:De}=M,He=E&&A===y.length-1?()=>w({query:j,isRetry:!0}):void 0;return D(Nt,{children:[d(me,{question:j,answer:Ae,searchResults:De,onRetry:He}),A<y.length-1&&d(T,{size:"m"})]},A)}),[y]),L=b||y.length>0||k,h=b||R||S.trim().length===0,W=()=>{h||(w({query:S}),m(""))},_e=z.length===0?null:d(T,{size:k?"m":"l"});return xe(x,[b,k]),g?D("div",{className:"vrcbChatbotWrapper",style:{zIndex:l},children:[D(B,{className:"vrcbHeader",spacing:"none",direction:"row",children:[d(v,{grow:1,alignItems:"center",children:n}),d(v,{alignItems:"center",children:d("button",{onClick:()=>f(!1),children:d(he,{size:"12px",color:"#2c313a"})})})]}),D(B,{direction:"column",spacing:"none",className:"vrcbChatbotInnerWrapper",children:[d(v,{className:"vrcbMessagesWrapper",basis:"fill",children:d("div",{ref:I,children:L?D(Me,{children:[d(T,{size:"xs"}),z,_e,k&&D(Me,{children:[d(me,{question:k.question,answer:k.answer,searchResults:k.results,onRetry:E?()=>w({query:k.question,isRetry:!0}):void 0,isStreaming:R}),d(T,{size:"l"})]}),b&&d(Ee,{}),d(B,{fullWidth:!0,justifyContent:"center",children:d(v,{children:d(oe,{color:"neutral",size:"xs",onClick:F,isDisabled:b,children:"Start new conversation"})})}),d(T,{size:"l"})]}):a})}),d(v,{grow:!1,shrink:!1,className:"vrcbChatInputContainer",children:d(Te,{placeholder:i,buttonLabel:"Send",query:S,setQuery:m,isButtonDisabled:h,onSubmit:W,size:zt[o]})})]})]}):d("button",{className:"vrcbChatbotButton",onClick:()=>f(!0),style:{zIndex:l},children:n})};var ge=`:host {
  all: initial;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.vrcbChatbotButton {
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 9999;
  background-color: #264cd6;
  color: #ffffff;
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  transition: all 0.2s;
  line-height: 1;
  cursor: pointer;
  font-size: 16px;
  padding: 8px 16px;
  height: 34px;
}
.vrcbChatbotButton:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.vrcbChatMessageContainer {
  display: flex;
}

.vrcbChatMessage {
  padding: 12px 16px;
  border-radius: 16px;
}

.vrcbChatMessageContainer--question {
  justify-content: flex-start;
  padding: 0 40px 0 12px;
}
.vrcbChatMessageContainer--question .vrcbChatMessage {
  color: #2c313a;
  font-weight: 600;
  font-size: 14px;
  padding-left: 0;
}

.vrcbChatMessageContainer--thinking,
.vrcbChatMessageContainer--answer {
  padding: 0 40px;
  padding-right: 12px;
}
.vrcbChatMessageContainer--thinking .vrcbChatMessage,
.vrcbChatMessageContainer--answer .vrcbChatMessage {
  background-color: #f3f7fb;
}

.vrcbChatMessageContainer--error,
.vrcbChatMessageContainer--answer {
  justify-content: flex-start;
}

.vrcbChatMessageContainer--error {
  padding: 0 24px;
  font-size: 12px;
}

.vrcbChatMessageContainer--thinking {
  justify-content: flex-end;
}
.vrcbChatMessageContainer--thinking .vrcbChatMessage {
  padding-left: 24px;
  padding-right: 24px;
}

.vrcbChatMessageContainer--answer .vrcbChatMessage {
  color: #000;
}

.vrcbChatMessageContainer--error .vrcbChatMessage {
  color: #c41535;
}

.vrcbChatInputContainer {
  position: relative;
}
.vrcbChatInputContainer::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
  pointer-events: none;
}

.vrcbChatSummaryCitation,
.vrcbChatSearchResultPosition {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000;
  padding: 2px 4px;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 600;
  line-height: 1.4;
}

.vrcbChatSummaryCitation {
  display: inline;
}

.vrcbChatbotWrapper {
  align-items: stretch;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 9999;
  max-width: 600px;
  width: calc(100vw - 24px);
  max-height: 800px;
  height: calc(100vh - 24px);
}

.vrcbChatbotInnerWrapper {
  gap: 8px;
  flex-basis: 100%;
  min-height: 0;
  padding: 0 8px 8px;
}

.vrcbMessagesWrapper {
  flex-basis: 100%;
  min-height: 0;
}
.vrcbMessagesWrapper > div {
  height: 100%;
  overflow-y: auto;
}

.vrcbHeader {
  border-bottom: 1px solid #e3e4f3;
  color: #69707d;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  padding: 8px;
}
.vrcbHeader > div {
  flex-direction: row;
}

.vrcbEmptyMessages {
  color: #000;
  font-weight: 600;
  height: 100%;
  opacity: 0.3;
}

.vrcbRetryButton {
  color: #264cd6;
  font-weight: 600;
  padding: 2px 4px;
}

@media (max-width: 700px) {
  .vrcbChatbotWrapper {
    right: 0;
    bottom: 0;
    width: 100vw;
    max-width: 100vw;
    border: none;
    border-top: 1px solid #cbcdde;
  }
}
@media (max-height: 840px) {
  .vrcbChatbotWrapper {
    right: 0;
    bottom: 0;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    border: none;
    border-left: 1px solid #cbcdde;
  }
}
.vrcbLoader,
.vrcbLoader:before,
.vrcbLoader:after {
  width: 8px;
  aspect-ratio: 0.5;
  display: grid;
  background: radial-gradient(#000 68%, rgba(0, 0, 0, 0) 72%) center/100% 50% no-repeat;
  animation: load 1.2s infinite linear calc(var(--_s, 0) * 0.4s);
  transform: translate(calc(var(--_s, 0) * 150%));
}

.vrcbLoader {
  opacity: 0.4;
}

.vrcbLoader:before,
.vrcbLoader:after {
  content: "";
  grid-area: 1/1;
  opacity: 1;
}

.vrcbLoader:before {
  --_s: -1;
}

.vrcbLoader:after {
  --_s: 1;
}

@keyframes load {
  20% {
    background-position: top;
  }
  40% {
    background-position: center;
  }
  60% {
    background-position: center;
  }
}
body,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: none;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a[href],
button,
[role=button] {
  cursor: pointer;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

input {
  margin: 0;
  padding: 0;
}

input:disabled {
  opacity: 1; /* required on iOS */
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  margin: 0;
}

fieldset {
  min-inline-size: auto;
}

.vuiAccordionHeader {
  font-size: 14px;
  border-bottom: 1px solid #cbcdde;
  width: 100%;
  padding: 8px 0;
}
.vuiAccordionHeader:hover {
  text-decoration: underline;
  background-color: #f3f7fb;
}

.vuiAccordionHeader__title {
  text-align: left;
}

.vuiBaseButtonIconContainer {
  line-height: 0;
}

.vuiBaseButtonLinkWrapper {
  text-decoration: none;
}
.vuiBaseButtonLinkWrapper:hover {
  text-decoration: none;
}

.vuiBaseButtonLinkWrapper--fullWidth {
  width: 100%;
}

.vuiBaseButton {
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  line-height: 1;
  cursor: pointer;
}

.vuiBaseButton--alignLeft {
  justify-content: flex-start;
}

.vuiBaseButton--alignCenter {
  justify-content: center;
}

.vuiBaseButton--alignRight {
  justify-content: flex-end;
}

.vuiBaseButton-isInert,
.vuiBaseButton-isDisabled {
  cursor: default;
  pointer-events: none;
}

.vuiBaseButton-isDisabled {
  opacity: 0.5;
}

.vuiBaseButton--left .vuiBaseButtonIconContainer {
  margin-right: 8px;
}

.vuiBaseButton--right {
  flex-direction: row-reverse;
}
.vuiBaseButton--right .vuiBaseButtonIconContainer {
  margin-left: 8px;
  margin-right: 0;
}

.vuiBaseButton--fullWidth {
  width: 100%;
}

.vuiBaseButton--xs {
  font-size: 14px;
  padding: 4px 8px;
  height: 24px;
}

.vuiBaseButton--s {
  font-size: 14px;
  padding: 6px 8px;
  height: 28px;
}

.vuiBaseButton--m {
  font-size: 16px;
  padding: 8px 16px;
  height: 34px;
}

.vuiBaseButton--l {
  font-size: 16px;
  padding: 12px 24px;
  height: 47px;
}

.vuiButtonPrimary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonPrimary--accent {
  color: #ffffff;
  background-color: #551edf;
  border: 1px solid #551edf;
}
.vuiButtonPrimary--accent.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--primary {
  color: #ffffff;
  background-color: #264cd6;
  border: 1px solid #264cd6;
}
.vuiButtonPrimary--primary.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--success {
  color: #ffffff;
  background-color: #04821f;
  border: 1px solid #04821f;
}
.vuiButtonPrimary--success.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--danger {
  color: #ffffff;
  background-color: #c41535;
  border: 1px solid #c41535;
}
.vuiButtonPrimary--danger.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--warning {
  color: #ffffff;
  background-color: #965a15;
  border: 1px solid #965a15;
}
.vuiButtonPrimary--warning.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--neutral {
  color: #2c313a;
  background-color: rgba(44, 49, 58, 0.1);
  border: 1px solid rgba(44, 49, 58, 0.1);
}
.vuiButtonPrimary--neutral.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--subdued {
  color: #69707d;
  background-color: rgba(105, 112, 125, 0.1);
  border: 1px solid rgba(105, 112, 125, 0.1);
}
.vuiButtonPrimary--subdued.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonSecondary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonSecondary--solid {
  background-color: #ffffff;
}

.vuiButtonSecondary--accent {
  border: 1px solid rgba(85, 30, 223, 0.5);
  color: #551edf;
}
.vuiButtonSecondary--accent.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--primary {
  border: 1px solid rgba(38, 76, 214, 0.5);
  color: #264cd6;
}
.vuiButtonSecondary--primary.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--success {
  border: 1px solid rgba(4, 130, 31, 0.5);
  color: #04821f;
}
.vuiButtonSecondary--success.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--danger {
  border: 1px solid rgba(196, 21, 53, 0.5);
  color: #c41535;
}
.vuiButtonSecondary--danger.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--warning {
  border: 1px solid rgba(150, 90, 21, 0.5);
  color: #965a15;
}
.vuiButtonSecondary--warning.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--neutral {
  border: 1px solid #cbcdde;
  color: #2c313a;
}
.vuiButtonSecondary--neutral.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--subdued {
  border: 1px solid #e3e4f3;
  color: #69707d;
}
.vuiButtonSecondary--subdued.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  gap: 0;
}

.vuiFlexContainer--spacingXxs {
  gap: 4px;
}

.vuiFlexContainer--spacingXs {
  gap: 8px;
}

.vuiFlexContainer--spacingS {
  gap: 12px;
}

.vuiFlexContainer--spacingM {
  gap: 16px;
}

.vuiFlexContainer--spacingL {
  gap: 24px;
}

.vuiFlexContainer--spacingXl {
  gap: 32px;
}

.vuiFlexContainer--spacingXxl {
  gap: 40px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiSearchInput {
  position: relative;
  display: flex;
  align-items: center;
}

.vuiSearchInput__input {
  flex-grow: 1;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  outline-width: 1px !important;
  outline-style: solid;
  outline-color: transparent;
  outline-offset: -1px !important;
}
.vuiSearchInput__input:focus-visible {
  outline-color: #264cd6 !important;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiSearchInput__submitButton {
  position: absolute;
  right: 12px;
  line-height: 0;
  color: #69707d;
  transition: all 0.2s;
}
.vuiSearchInput__submitButton:hover {
  color: #551edf;
}

.vuiSearchInput--m .vuiSearchInput__input {
  padding: 8px 16px;
  font-size: 14px;
}

.vuiSearchInput--l .vuiSearchInput__input {
  padding: 12px 16px;
  font-size: 18px;
}

.vuiSpinner {
  display: inline-block;
}

.vuiSpinner--accent svg path,
.vuiSpinner--accent svg rect {
  fill: #551edf;
}

.vuiSpinner--primary svg path,
.vuiSpinner--primary svg rect {
  fill: #264cd6;
}

.vuiSpinner--success svg path,
.vuiSpinner--success svg rect {
  fill: #04821f;
}

.vuiSpinner--danger svg path,
.vuiSpinner--danger svg rect {
  fill: #c41535;
}

.vuiSpinner--warning svg path,
.vuiSpinner--warning svg rect {
  fill: #965a15;
}

.vuiSpinner--empty svg path,
.vuiSpinner--empty svg rect {
  fill: #ffffff;
}

.vuiSpinner--dark svg path,
.vuiSpinner--dark svg rect {
  fill: #2c313a;
}

.vuiSpinner--xs {
  width: 14px;
  height: 14px;
}

.vuiSpinner--s {
  width: 15.9px;
  height: 15.9px;
}

.vuiSpinner--m {
  width: 20.08px;
  height: 20.08px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText a {
  color: #264cd6;
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: #264cd6 !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}`;import{Fragment as _t,jsx as q}from"react/jsx-runtime";var Vt=({customerId:e,apiKey:t,corpusIds:r,title:n,placeholder:i,inputSize:o,emptyStateDisplay:a,isInitiallyOpen:s,zIndex:l,enableStreaming:c=!0,language:p="eng"})=>q("div",{children:q(Le,{customerId:e,corpusIds:r,apiKey:t,title:n,placeholder:i,inputSize:o,emptyStateDisplay:a,isInitiallyOpen:s,zIndex:l,enableStreaming:c,language:p})}),fe=class extends HTMLElement{static get observedAttributes(){return["customerid","corpusids","apikey","title","placeholder","inputsize","isinitiallyopen","zindex","emptystatedisplayupdatetime","enablestreaming","language"]}constructor(){super(),this.sr=this.attachShadow({mode:"open"});try{this.sheet=new CSSStyleSheet,this.sheet.replaceSync(ge),this.sr.adoptedStyleSheets=[this.sheet]}catch{let t=document.createElement("style");t.innerText=ge,this.sr.appendChild(t)}this.mountPoint=document.createElement("div"),this.sr.appendChild(this.mountPoint)}setEmptyStateDisplay(t){this.emptyStateDisplay=t,this.setAttribute("emptystatedisplayupdatetime",Date.now().toString())}connectedCallback(){var f,S,m,w,F,y,b,E;let t=(f=this.getAttribute("customerId"))!=null?f:"",r=((S=this.getAttribute("corpusIds"))!=null?S:"").split(" "),n=(m=this.getAttribute("apiKey"))!=null?m:"",i=(w=this.getAttribute("title"))!=null?w:void 0,o=(F=this.getAttribute("placeholder"))!=null?F:void 0,a=(y=this.getAttribute("inputSize"))!=null?y:void 0,s=this.getAttribute("isInitiallyOpen")==="true",l=(b=this.emptyStateDisplay)!=null?b:void 0,c=this.getAttribute("zIndex")!==null?parseInt(this.getAttribute("zIndex")):void 0,p=this.getAttribute("enableStreaming")!==null?this.getAttribute("enableStreaming")=="true":void 0,g=(E=this.getAttribute("language"))!=null?E:void 0;Ve.render(q(_t,{children:q(Vt,{customerId:t,corpusIds:r,apiKey:n,title:i,placeholder:o,inputSize:a,emptyStateDisplay:l,isInitiallyOpen:s,zIndex:c,enableStreaming:p,language:g})}),this.mountPoint)}attributeChangedCallback(){this.connectedCallback()}};window.customElements.get("react-chatbot")||window.customElements.define("react-chatbot",fe);var Si=e=>{let t=Lt(null);Mt(()=>{t.current&&e.emptyStateDisplay&&t.current.setEmptyStateDisplay(e.emptyStateDisplay)},[e]);let r=e,n=Object.keys(e).reduce((i,o)=>(o==="emptyStateDisplay"||(o==="corpusIds"?i[o]=r.corpusIds.join(" "):i[o]=r[o]),i),{});return q("react-chatbot",{ref:t,...n})};export{Si as ReactChatbot};
